// extracted by mini-css-extract-plugin
export var carrierNotice = "_kd-5";
export var carrierNoticePlaceholder = "_kd-6";
export var deliveryRow = "_kd-c";
export var fixedHeight = "_kd-4";
export var freightLogo = "_kd-b";
export var fullWidth = "_kd-3";
export var priceColumn = "_kd-7";
export var radioSelected = "_kd-9";
export var radioUnselected = "_kd-8";
export var selectedOption = "_kd-2";
export var selectedOptionContainer = "_kd-1";
export var selection = "_kd-0";
export var tallSkeletonText = "_kd-a";